<template src="./display.html"></template>

<script>
import axios from 'axios'
  import SettingSidebar from '../../common/settingsidebar/settingsidebar'
  import auth from '../../../helpers/auth'

  export default {
    components: {
      'app-setting-sidebar': SettingSidebar
    },
    computed: {
      isOnSiteUser: function () {
        return this.$store.getters['user/isOnSiteStaff']
      }
    },
    data: function () {
      return {
        settings: {
          business_name: '',
          abn: '',
          phone: '',
          email: '',
          quote_terms: '',
          invoice_terms: '',
          invoice_payment_terms: '',
          quote_validity_days: 30,
          invoice_due_days: 7,
          images: [],
          address: {
            address_line_1: '',
            address_line_2: '',
            suburb: '',
            state: '',
            post_code: ''
          }
        },
        templates: {
          invoice_message: '',
          quote_message: ''
        }
      }
    },
    methods: {
      getSettings: function () {
        axios.get('/api/setting/display').then(response => {
          if (response.data) {
            this.settings = Object.assign({}, this.settings, response.data, {
              quote_validity_days: parseInt(response.data.quote_validity_days, 10) || 30,
              invoice_due_days: parseInt(response.data.invoice_due_days, 10) || 7
            })
          }
        }).catch(error => {
          console.error('Error loading display settings:', error)
          this.errorNotification('Failed to load display settings')
        })
      },
      getTemplates: function () {
        axios.get('/api/email/template').then(response => {
          if (response.data) {
            this.templates = response.data
          }
        }).catch(error => {
          console.error('Error loading email templates:', error)
          this.errorNotification('Failed to load email templates')
        })
      },
      saveSettings: function () {
        axios.put('/api/setting/display', this.settings).then(response => {
          this.successNotification('Display settings saved successfully')
        }).catch(error => {
          console.error('Error saving display settings:', error)
          this.errorNotification('Failed to save display settings')
        })
      },
      saveTemplates: function () {
        axios.put('/api/email/template', this.templates).then(response => {
          this.successNotification('Email templates saved successfully')
        }).catch(error => {
          console.error('Error saving email templates:', error)
          this.errorNotification('Failed to save email templates')
        })
      }
    },
    created: function () {
      /**
       * Component requires authentication, check if user is authenticated
       */
      auth.check(this).then(() => {
        this.getSettings()
        this.getTemplates()
        this.$nextTick(() => {
          const $menu = $(this.$el).find('.ui.menu .item')
          $menu.tab()
          if (this.isOnSiteUser) {
            $menu.tab('change tab', 'second')
          }
        })
      }).catch(() => {})
    },
    mounted: function () {
      /**
       * Initialise Semantic UI tooltips (e.g. placeholder help next to Quote Message / Invoice Message)
       */
      $(this.$el).find('.tooltip').popup({ inline: true })
    }
  }
</script>

<style>

</style>
